import React from 'react';
import useMedicineLayoutStore from '../medicine.zustandstore';
import '../medicine.css';

const Pagination = () => {
    const { pagination, fetchMedicines } = useMedicineLayoutStore();
    const { totalPages, currentPage } = pagination || {};
    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
          fetchMedicines(page);
        }
    };
    if (!totalPages || totalPages <= 1) return null;
    return (
        <div style={{ display: 'flex', justifyContent: 'center', margin: '16px 0' }}>
            <button
                className="pagination-btn-small"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
            >
                Prev
            </button>

            {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;
                return (
                    <button
                        key={page}
                        className="pagination-btn-small"
                        style={{
                            fontWeight: currentPage === page ? 'bold' : 'normal',
                            opacity: currentPage === page ? 1 : 0.7,
                        }}
                        onClick={() => handlePageClick(page)}
                    >
                        {page}
                    </button>
                );
            })}

            <button
                className="pagination-btn-small"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                Next
            </button>
        </div>
    );
  };
export default Pagination;